export const HEADER_FIELDS = [
  ['legal_entity', 'Contract (legal entity)'], ['client_name', 'Settlement report (client)'], ['project_code', 'Project ID'],
  ['account_manager', 'Account manager'], ['company_name', 'Company'], ['address_line_1', 'Address 1'], ['address_line_2', 'Address 2'],
  ['address_line_3', 'Address 3'], ['address_line_4', 'Address 4'], ['address_line_5', 'Address 5'], ['contact_email', 'Contact email'],
  ['vat_number', 'VAT number'], ['contract_basis', 'Contract basis'], ['power_contract', 'Power contract'], ['om_terms', 'O&M terms'],
  ['software_licence_terms', 'Software licence terms'], ['payment_terms', 'Payment terms'],
  ['reactive_maintenance_terms', 'Reactive maintenance terms'],
];

/* Screens/controls that are switched off. Set the variable to 'true' when building to bring one back (read when used, so tests can set it).
 *   REACT_APP_SHOW_HISTORIC=true     the Historic tab
 *   REACT_APP_PERIOD_PICKER=true     the Year / Quarter / Month drop-downs on the Reports screen can be changed */
export const showHistoric = () => process.env.REACT_APP_SHOW_HISTORIC === 'true';
export const periodPickerEnabled = () => process.env.REACT_APP_PERIOD_PICKER === 'true';

/* The account managers shown in the left-hand menu. A report belongs to the one whose first name its account_manager field starts with
 * ("Carol" and "Carol Wilson" both belong to Carol); anything else is listed under "Unassigned". */
export const ACCOUNT_MANAGERS = ['Carol', 'Robyn', 'Jonah'];
export const UNASSIGNED = 'Unassigned';
/** The first name of an account manager value ("Carol Wilson" -> "carol"); the server compares the same way. */
export const firstNameOf = (v) => String(v || '').trim().split(/\s+/)[0].toLowerCase();
/** Is `user` (their account_manager, from the e-mail table) the account manager of `report`? First names only, so "Carol Wilson" matches "Carol". */
export const isManagerOf = (user, r) => !!user && !!firstNameOf(user.account_manager) && firstNameOf(user.account_manager) === firstNameOf(r?.account_manager);
export const managerOf = (r) => {
  const first = String(r?.account_manager || '').trim().split(/\s+/)[0].toLowerCase();
  return ACCOUNT_MANAGERS.find((n) => n.toLowerCase() === first) || UNASSIGNED;
};
